<div>
  <ng-container *ngIf="!externalCrmAccount?.id">
    <ion-button fill="outline" (click)="openModal()">
      <ion-icon name="unlink-outline" class="icon-padded"></ion-icon>
      Link to a {{ externalCrmType }} account
    </ion-button>
  </ng-container>
  <ng-container *ngIf="externalCrmAccount?.id">
    <ion-button color="light" (click)="openModal()">
      <ion-icon name="link-outline" class="icon-padded"></ion-icon>
      Linked to {{ externalCrmAccount?.name }}
    </ion-button>
    <ion-button color="danger" fill="clear" (click)="clear()">
      Unlink
    </ion-button>
  </ng-container>
</div>
